import React, { useReducer, useState, useEffect } from 'react'
import GridColumnHeader from './GridColumnHeader'
import { Modal, ModalBody } from 'reactstrap'
import ModalHeader from './ModalHeader'
import DataGrid from 'react-data-grid';
import { ServerRequestProtected } from '../../../utils/ServerDataRequest';
import { enumUtil } from '../../../utils/Enum';
import NotificationHandler from '../../../utils/NotificationHandler';
import Table from './Table';
import { SelectColumn } from "react-data-grid"
import Loader from '../../shared/Loader/Loader';
import isNull from '../../../utils/NullChecking';
import warning from 'warning';
import SuperSearchList from '../../shared/SuperSearch/SuperSearchList';
import UpdateReduxDropDownCodes from '../../shared/UpdateReduxDropDownCodes';
import { useSelector } from 'react-redux';
// import { display } from 'html2canvas/dist/types/css/property-descriptors/display';



const MasterList = (props) => {
    const { isOpen, onClose, LoadData, GridTableName, SaveTableName, type, Name, IsEditAllowed } = { ...props }
    console.log(props, 'props');
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer)

    //   const [isOpen, setmasterList] = useState(false);
    const API_URL = enumUtil.controller.General
    const API_URL_MasterList = enumUtil.controller.MasterList
    let Master_Modal = {
        Category: ""
    }

    const [masterListData, setmasterListData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedRows, setSelectedRows] = useState(new Set())
    const [selectedClaimId, setSelectedClaimID] = useState([])
    const [searchParam, setSearchParam] = useState();
    const [EnterParam, setEnterParam] = useState();
    const [dropdownOption, setDropdownOption] = useState([])
    const [mainMasterModal, setmainMasterModal] = useState(Master_Modal);
    const [selectRowData, setSelectRowData] = useState([]);



    const [PerPage, setPerPage] = useState(10);
    const [PageNo, setPageNo] = useState(1);
    const [TotalPages, setTotalPages] = useState();

    const LoadDataPOS = (param) => {
        setSelectedClaimID('')
        setIsLoading(true)
        setSelectedRows(new Set())
        setmasterListData([])
        ServerRequestProtected(API_URL + "/FindBySingleCriteria", 'post', {
            "TableName": GridTableName,
            "SearchParam": param,
        }).then((response) => {
            setIsLoading(false)
            handleGridHeader({ defaultData: response.Rows })
            setmasterListData(response.Rows)
            setTotalPages(response.count.NumOfPages);
        }).catch((error) => {
            setIsLoading(false)
            NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
        })
    }


    const LoadDatAothers = (param) => {
        setSelectedClaimID('')
        setIsLoading(true)
        setSelectedRows(new Set())
        setmasterListData([])
        ServerRequestProtected(API_URL + "/FindBySingleCriteria", 'post', {
            "TableName": GridTableName,
            "SearchCriteria":
            {
                "Category": mainMasterModal.Category + "",
                "Code": param
            },
        }).then((response) => {
            setIsLoading(false)
            handleGridHeader({ defaultData: response.Rows })
            setmasterListData(response.Rows)
            setTotalPages(response.count.NumOfPages);
        }).catch((error) => {
            setIsLoading(false)
            NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
        })
    }

    useEffect(() => {
        if (Name === "RevenueCode") {
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/DropDown", 'post', {
                "TableName": enumUtil.enumAPITableName.MasterListRevenueCode,
            })
                .then((response) => {
                    setIsLoading(false)
                    setDropdownOption(response)
                }).catch((error) => {
                    setIsLoading(false)
                })
        }
        else if (Name === "Modifier") {
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/DropDown", 'post', {
                "TableName": enumUtil.enumAPITableName.MasterListModifier,
            })
                .then((response) => {
                    setIsLoading(false)
                    setDropdownOption(response)
                }).catch((error) => {
                    setIsLoading(false)
                })
        }

    }, [])

    useEffect(() => {
        if (Name === "POS" || Name === "InsuranceType") {
            LoadDataPOS(searchParam);
        }
        else {
            LoadDatAothers(searchParam)
        }

    }, [PerPage, PageNo, mainMasterModal.Category])

    const onRowSelection = (listOfIds) => {
        console.log(listOfIds, 'listOfIds');
        let newList = []
        const tempIdsArr = []
        listOfIds.forEach((id) => {
            if (id === '') {
                NotificationHandler("Please select Correct Record(s)", enumUtil.enumtoaster.warning);
                warning(id)
            }
            else {
                masterListData.forEach((el) => {
                    if (el.MLPOSCodeID === id || el.MLModifierCodeID === id || el.MLRevenueCodeID === id || el.MasterListInsuranceTypeID === id) {
                        newList.push(el)
                        tempIdsArr.push(id);
                    }

                })
            }

        })
        setSelectedRows(listOfIds)
        console.log(listOfIds, '    console.log(commaSeparatedIds)');

        const commaSeparatedIds = tempIdsArr.join(', ');
        setSelectedClaimID(commaSeparatedIds);
        console.log(commaSeparatedIds)
        setSelectRowData(newList)
    }

    console.log(selectRowData, 'selectRowData');

    const rowKeyGetter = (row) => {
        console.log(row, "row");
        let SelectedRow;

        if (GridTableName === 'MasterListPOS') {


            if (row.Added === 'No') {

                SelectedRow = row.MLPOSCodeID
            }
            else {
                SelectedRow = ''
            }


        }
        else if (GridTableName === 'MasterListModifier') {
            if (row.Added === 'No') {

                SelectedRow = row.MLModifierCodeID
            }
            else {
                SelectedRow = ''
            }
        }
        else if (GridTableName === 'MasterListRevenueCode') {
            if (row.Added === 'No') {

                SelectedRow = row.MLRevenueCodeID
            }
        }
        else if (GridTableName === 'MasterListInsuranceType') {
            if (row.Added === 'No') {
                SelectedRow = row.MasterListInsuranceTypeID
            }

            else {
                SelectedRow = ''
            }
        }

        return SelectedRow;
    }
    const handleSavePOSMasterList = async () => {
        if (IsEditAllowed) {
            if (selectedClaimId.length === 0) {
                NotificationHandler("Please select Record(s)", enumUtil.enumtoaster.warning);
            } else {
                let saveModal;
                let modalPOS = {
                    TableName: SaveTableName,
                    ID: '0',
                    DATA: {
                        "MLPOSCodeID": selectedClaimId
                    },
                }
                let modalModifier = {
                    TableName: SaveTableName,
                    ID: "0",
                    DATA: {

                        "MLModifierIDS": selectedClaimId
                    }
                }
                let modalRevenue =
                {
                    TableName: SaveTableName,
                    ID: "0",
                    DATA: {

                        "MLRevenueIDS": selectedClaimId
                    }
                }
                let InsuranceType =
                {
                    TableName: SaveTableName,
                    ID: "0",
                    DATA: {

                        "MasterListInsuranceTypeID": selectedClaimId
                    }
                }
                if (SaveTableName === 'MASTERLISTPOS') {

                    saveModal = modalPOS
                }
                else if (SaveTableName === 'MASTERLISTMODIFIER') {
                    saveModal = modalModifier
                }
                else if (SaveTableName === 'MASTERLISTREVENUECODE') {
                    saveModal = modalRevenue
                }
                else if (SaveTableName === 'MasterListInsuranceType') {
                    saveModal = InsuranceType
                }
                {
                    setIsLoading(true)
                    ServerRequestProtected(API_URL_MasterList + "/SaveMasterListCodes", 'post', saveModal)
                        .then((response) => {
                            setIsLoading(false)
                            if (!isNull(response.id)) {
                                if (SaveTableName === 'MASTERLISTPOS') {
                                    selectRowData.forEach((item) => {
                                        UpdateReduxDropDownCodes(
                                            0,
                                            DropDowns.POS,
                                           response.id,                                 
                                            item.POSCode + ' - ' + item.Description,            
                                            item.POSCode                                      
                                        )
                                    })
                                }
                                // UpdateReduxDropDownCodes(POSCodes, DropDowns.POS, response.id, mainPOSModal.POSCode + ' - ' + mainPOSModal.Description, mainPOSModal.POSCode)

                                NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
                                LoadData()

                                onClose()
                            }
                        }).catch((error) => {
                            setIsLoading(false)
                            if (!isNull(error.response.data)) { NotificationHandler(error.response.data, enumUtil.enumtoaster.error) }
                            else { NotificationHandler(error.response.data, enumUtil.enumtoaster.error) }
                        })
                }
            }
        }
    }
    const SearchOnEnter = (e) => {
        if (e.key === "Enter") {
            setEnterParam(e.target.value)
            setSearchParam(EnterParam)
            if (Name === 'POS') {
                LoadDataPOS(searchParam)
            }
            else {
                LoadDatAothers(searchParam)
            }
        }
    }
    const [gridHeader, handleGridHeader] = useReducer((prev, next) => {
        return { ...prev, ...next }
    }, { defaultData: '', activeSortIcon: '' })
    const columnsAll = [
        {
            ...SelectColumn,
        },
        {
            key: 'Added',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-location'} headerName={'Added'} sortIcon={true} type={'string'} colKey={'Added'} data={masterListData} setData={setmasterListData} />),
            width: 80,
            resizable: true,
            renderCell: ({ row }) => {
                return (
                    <>
                        {row.Added === 'Yes' ? <div className='Yes pill'>
                            {row.Added}
                        </div> : <div className='No pill'>
                            {row.Added}
                        </div>}

                    </>
                );
            }
        },



        // { key: 'BeforeUpdateValue', name: 'Added' },
        {
            key: 'POSCode',
            key: GridTableName === 'MasterListPOS' ? 'POSCode' : GridTableName === 'MasterListModifier' ? 'ModifierCode' : GridTableName === 'MasterListRevenueCode' ? "RevenueCode" : GridTableName === 'MasterListInsuranceType' ? "InsuranceTypeCode" : '',
            width: 80,
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'Code'} sortIcon={true} type={'string'} colKey={GridTableName === 'MasterListPOS' ? 'POSCode' : GridTableName === 'MasterListModifier' ? 'ModifierCode' : GridTableName === 'MasterListRevenueCode' ? "RevenueCode" : GridTableName === 'MasterListInsuranceType' ? "InsuranceTypeCode" : ""} />),
        },
        {
            key: 'Description',
            width: 417,
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'Description'} sortIcon={true} type={'string'} colKey={'Description'} />),
        },
    ]
    const masterHeader = () => {
        return <p className="heading sm">Add from Master List    </p>;
    };

    const handleChange = (e) => {
        let { name, value } = e.target;
        let modal = { ...mainMasterModal };
        modal[name] = value
        setmainMasterModal(modal)

    }
    const handleSelectedDataa = (selectedData, name, type) => {
        if (type === 'client' && !isNull(selectedData)) {

            if (name === 'Category') {
                setmainMasterModal({ ...mainMasterModal, Category: selectedData.value + "" })
            }
        } else {
        }
        return selectedData
    }

    const MasterListModalBody = () => {
        return (
            <>
                <div className='container-fluid  br-clr mt-2'>
                    <div className="ar-grid-border row">
                        <div className={
                            Name === "RevenueCode" || Name === "Modifier"
                                ? "col-8 mb-2 p-0"
                                : "col-12 mb-2 p-0"
                        }>
                            <div className="input">
                                <div className='input-group hk-input-search'>
                                    <input type="text" className='form-control fc-xs'
                                        placeholder='Search For MasterList codes….'
                                        onChange={e => setSearchParam(e.target.value)}
                                        onKeyDown={SearchOnEnter}
                                    />
                                    <span className="input-group-text seraches" id="basic-addon2" onClick={() => { { Name === "POS" ? LoadDataPOS(searchParam) : LoadDatAothers(searchParam) } }}>
                                        <i className="bi bi-search" ></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        {Name === "RevenueCode" || Name === "Modifier" ?
                            <>
                                <div className="col-1"></div>
                                <div className="col-3 mb-2 p-0">
                                    <div className='input form-group'>
                                        <SuperSearchList
                                            type="client"
                                            id='Category'
                                            name='Category'
                                            searchValue={mainMasterModal.Category}
                                            data={dropdownOption}
                                            onChange={handleChange}
                                            getSelectedData={handleSelectedDataa}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                        />
                                    </div>
                                </div>
                            </>
                            : <></>}

                        {isLoading ? <Loader /> : null}
                        <div className="col-12 px-0">
                            <DataGrid
                                columns={columnsAll}
                                rows={masterListData}
                                className='all_audit custom_checkboxes_gird_two fill-grid DataGrid-Table bg-light-blue sr-table popper-t-table'
                                rowHeight={25}
                                hidePagination={true}
                                selectedRows={selectedRows}
                                onSelectedRowsChange={onRowSelection}
                                rowKeyGetter={rowKeyGetter}
                            // className="all_audit fill-grid DataGrid-Table bg-light-blue sr-table popper-t-table"
                            />
                        </div>
                        {/* <div className="col-12 p-0 master_footer d-flex gap-3 mt-2 justify-content-end">
                            <button class="btn btn-gray" onClick={onClose}>Close</button>
                            <button class="btn btn-orange" onClick={handleSavePOSMasterList}>Add</button>
                        </div> */}
                        <div className="d-flex align-items-center px-10 pt-2 br-top-1 za_br_light justify-content-end gap-2 ar_footer">
                            <button className='btn btn-outline h-100 px-10 dark-clr' onClick={onClose}>Close</button>
                            <button className={IsEditAllowed ? 'btn btn-validate h-100 px-10' : 'btn btn-validate h-100 px-10 disabled'} onClick={handleSavePOSMasterList}>Add</button>
                        </div>
                    </div>
                </div>
            </>
        )
    }
    return (
        <React.Fragment>
            {type && type === "Wizard" ?
                <div>
                    {isLoading ? <Loader /> : null}
                    <div className='px-10 pb-15 form-rounded'>
                        {MasterListModalBody()}
                    </div>
                </div>
                :
                <Modal show={isOpen} isOpen={isOpen} onHide={isOpen} backdrop="static" keyboard={false} centered className="app-modal modal-lg hk-modal-v1 master_list_modal ">
                    <ModalBody>
                        <ModalHeader HeaderName={masterHeader} DeletePopup={""} isClosed={onClose} key={'000'} Name={'MasterList'} />
                        {isLoading ? <Loader /> : null}
                        {MasterListModalBody()}
                    </ModalBody>
                </Modal>
            }
        </React.Fragment>
    )
}

export default MasterList